export const buildShortcutKey = (item = {}) => {
  if (item.path) {
    return `path:${item.path}`;
  }
  return `title:${item.title || ''}`;
};

export const flattenSidebarConfig = (navConfig = []) => {
  const result = [];

  const walk = (items = [], section = '', parentIcon = null) => {
    items.forEach((item) => {
      if (Array.isArray(item.children) && item.children.length > 0) {
        walk(item.children, section, item.icon || parentIcon || null);
        return;
      }

      if (!item.path) {
        return;
      }

      result.push({
        shortcut_key: buildShortcutKey(item),
        title: item.title,
        path: item.path,
        permission_key: item.permissions || null,
        section: section || null,
        icon: item.icon || parentIcon || null,
      });
    });
  };

  (navConfig || []).forEach((section) => {
    walk(section.items || [], section.subheader || '');
  });

  return result;
};

export const sanitizeShortcuts = (shortcuts = []) => {
  const seen = new Set();
  const normalized = [];

  (shortcuts || []).forEach((item) => {
    if (!item || !item.path) {
      return;
    }

    const shortcutKey = item.shortcut_key || buildShortcutKey(item);
    if (!shortcutKey || seen.has(shortcutKey)) {
      return;
    }

    seen.add(shortcutKey);
    normalized.push({
      shortcut_key: shortcutKey,
      title: item.title || item.path,
      path: item.path,
      permission_key: item.permission_key || null,
      section: item.section || null,
    });
  });

  return normalized;
};
